import { Card, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

export const BlogCard = ({ blogData }) => {
  const { title, excerpt, cardHeaderUrl, slug } = blogData;
  const linkToBlog = `/blog/${slug}`;

  return (
    <Col className="d-flex mb-0">
      <Card className="d-flex flex-column mb-0">
        <Link to={linkToBlog} className="stretched-link" />
        {cardHeaderUrl && <img src={cardHeaderUrl} alt="Featured" className="full-image" />}
        <Card.Footer className="d-flex flex-column flex-grow-1">
          <h4 dangerouslySetInnerHTML={{ __html: title.rendered }} />
          <p dangerouslySetInnerHTML={{ __html: excerpt.rendered }} className="truncate-2 mt-auto" />
          <Link className="btn btn-block btn-primary" to={linkToBlog}>
            Read More
          </Link>
        </Card.Footer>
      </Card>
    </Col>
  );
};
